import React, { Fragment } from 'react'

import CalendarRow from './CalendarRow'
import CalendarDay from './CalendarDay'

const CalendarCells = ({ currentMonth, ...props }) => {
  const monthStart = currentMonth.clone().startOf('month')
  const monthEnd = monthStart.clone().endOf('month')
  const startDate = monthStart.clone().startOf('isoWeek')
  const endDate = monthEnd.clone().endOf('isoWeek')

  let day = startDate
  let week = 0
  let days = []
  let rows = []

  while (day.isBefore(endDate)) {
    for (let i = 0; i < 7; i++) {
      const _day = day.clone()
      days.push(
        <CalendarDay
          key={_day}
          day={_day}
          week={week}
          currentMonth={currentMonth}
          {...props}
        />
      )
      day = day.add(1, 'day')
    }

    rows.push(<CalendarRow key={day} days={days} week={week} {...props} />)
    week += 1
    days = []
  }

  return <Fragment>{rows}</Fragment>
}

export default CalendarCells



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/CalendarCells.js